module.exports = __webpack_public_path__ + "static/goodjuju_v1-76d98116cf380ab1a35146cbba692640.jpg";